import React from 'react';

const CSS = require('./Separator.module.scss');

interface SeparatorProps {
  text?: string;
}

function Separator({ text }: SeparatorProps) {
  return (
    <div className={CSS.Separator}>
      <hr className={CSS.Line} />
      <span>{text || 'or'}</span>
      <hr className={CSS.Line} />
    </div>
  );
}

export default Separator;
